<section>
  @if (loading) {
    <mat-card class="loading">
      <mat-card-content>
        <mat-icon>autorenew</mat-icon>
        Loading&hellip;
      </mat-card-content>
    </mat-card>
  }
  @if (!loading) {
    <mat-card>
      <mat-toolbar class="grey-toolbar">
        <span [title]="Organisation.title" class="title">{{Organisation.title}}</span>
        <button
          mat-button
          matTooltip="Back to dashboard."
          routerLink="/dashboard/organisation-admin"
          >
          <mat-icon>dashboard</mat-icon>
          Dashboard
        </button>
        @if (Organisation.type == 'club' || Organisation.type == 'network' || Organisation.slug == 'the-odney-club') {
          <button
            (click)="listMembers()"
            mat-button
            matTooltip="List organisation members."
            >
            <mat-icon>people</mat-icon>
            Members
          </button>
        }
        <button
          (click)="listLocations()"
          mat-button
          matTooltip="List organisation event locations."
          >
          <mat-icon>location_on</mat-icon>
          Locations
        </button>
        <button
          [routerLink]="['/dashboard/listing-admin']"
          [queryParams]="{organisationId: Organisation.id}"
          mat-button
          matTooltip="View organisation pages."
          >
          <mat-icon>list</mat-icon>
          Pages
        </button>
        <button
          [routerLink]="['/dashboard/event-admin']"
          [queryParams]="{organisationId: Organisation.id}"
          mat-button
          matTooltip="View organisation event."
          >
          <mat-icon>list</mat-icon>
          Events
        </button>
      </mat-toolbar>
      <mat-card-actions>
        <a
          [href]="leisureUrl + '/company/' + Organisation.slug"
          mat-button
          matTooltip="View organisation page."
          target="_blank"
          >
          <mat-icon>visibility</mat-icon>
          View
        </a>
        <button
          (click)="edit(Organisation)"
          [disabled]="!Organisation.product_id"
          mat-button
          matTooltip="Edit organisation."
          >
          <mat-icon>edit</mat-icon>
          Edit
        </button>
        <button
          (click)="listCarousel()"
          [disabled]="!Organisation.product_id"
          mat-button
          matTooltip="View organisation images."
          >
          <mat-icon>photo_library</mat-icon>
          Images
        </button>
        <button
          (click)="listProductInfo()"
          [disabled]="!Organisation.product_id"
          mat-button
          matTooltip="View organisation extra info."
          >
          <mat-icon>info_outline</mat-icon>
          Extra Info
        </button>
      </mat-card-actions>
      <carousel-images-view
        [DataSource]="CarouselImageDataSource"
        [editable]="false"
      ></carousel-images-view>
      <mat-card-content>
        <section [innerHTML]="Organisation.description"></section>
        <listing-offer [extraInfo]="Organisation.extraInfo"></listing-offer>
      </mat-card-content>
    </mat-card>
  }
</section>
